<div class="flex flex-row items-center justify-start gap-2 mb-2">
    <h2 class="text-xl font-bold text-darkGraySubtitleColor">
        {{ 'seasons.season-creation.' + translationKey() + '.title' | translate }}
    </h2>
    @if (enableIcon()) {
        <span
            class="icon-edit cursor-pointer text-lg transition-colors"
            [style.color]="isDisabled() ? 'rgb(var(--ui-4))' : 'rgb(var(--ui-2))'"
            (click)="isDisabled.set(!isDisabled())"
        ></span>
    }
</div>
<p class="mb-4 text-base text-darkGraySubtitleColor">
    {{ 'seasons.season-creation.' + translationKey() + '.subtitle' | translate }}
</p>
